import Vue from 'vue'
import Router from 'vue-router'
const AsyncDashboard = () => import('@/components/home/dashboard.vue');
const AsyncGroupVisits = () => import('@/components/groupvisits/GroupVisits.vue');
const AsyncTrainees = () => import('@/components/trainees/Trainees.vue');
const AsyncCategories = () => import('@/components/descriptions/CategoriesList.vue');
const AsyncDescriptions = () => import('@/components/descriptions/DescriptionList.vue');
const AsyncP1Bufor = () => import('@/components/visits/BuforP1.vue');
const AsyncZabiegi = () => import("@/components/zabiegi/Zabiegi.vue")
const AsyncVisitsZabiegi = () => import("@/components/visits/VisitsZabiegi.vue")
const AsyncChangePassword = () => import("@/components/auth/ChangePassword.vue")
const AsyncSettings2FA = () => import("@/components/auth/Settings2FA.vue")
const AsyncVouchery = () => import("@/components/vouchery/Vouchery.vue")
const AsyncPrzerwy = () => import("@/components/therapists/QuickBreaksStandAlone.vue")
const AsyncReserves = () => import("@/components/reserves/Reserves.vue")
const AsyncDniWolne = () => import("@/components/daysoffs/ListDaysOffs.vue")
const AsyncSMSSendConfiguration = () => import("@/components/admin/sms/AndroidSMSConfiguration.vue")
const AsyncPokoSmsConfiguration = () => import("@/components/admin/sms/PokoSmsConfiguration.vue")
const AsyncVisitsRooms = () => import("@/components/visits/VisitsRooms.vue")
const AsyncSendSMS = () => import("@/components/sms/SendSMS")
const AsyncSMSCenter = () => import("@/components/sms/SMSCenter")
const AsyncPayU = () => import("@/components/payu/payu")
const AsyncSigningTemplates = () => import("@/components/admin/podpisy/SigningTemplates.vue")
const AsyncSigningTerminals = () => import("@/components/admin/podpisy/SigningTerminals.vue")
import Login from '@/components/auth/Login'
import Admin from '@/components/admin/Admin.vue'
import UsersAdmin from '@/components/admin/users/Users'
import RolesAdmin from '@/components/admin/roles/Roles'
import Rooms from '@/components/admin/rooms/Rooms'
import Clients from '@/components/clients/Clients'
import Therapists from '@/components/therapists/Therapists'
import Visits from '@/components/visits/Visits'
import Reports from '@/components/reports/Reports'
import MyCalendar from '@/components/visits/MyCalendar'
import CompanySettings from '@/components/admin/settings/CompanySettings'
import {ability} from '@/store/ability'
import {store} from '@/store/'
import { settingsService } from '@/services'
Vue.use(Router)


async function redirectIfNoFeature(to,from,next,resource)
{
  const features = await getFeatureState()

  if(features === null || !features[resource]) {
    next({name: 'Dashboard'})
  } else  {
    next()
  }
}
function getFeatureState()
{
  return new Promise((resolve) => {
    if(store.state.featuresModule.features === undefined) {
      const unwatch = store.watch( () => store.state.featuresModule.features, (value) => {
        unwatch()
        resolve(value)
      })
    } else {
      resolve(store.state.featuresModule.features)
    }
  })
}
export const router =  new Router({
  routes: [
    { path: '/', name: 'Dashboard', component: AsyncDashboard },
    { path: '/login', name: 'Login', component: Login },
    {
      path: '/admin',      
      component: Admin,
      children: [
        { path: '', redirect: '/admin/users'},
        { path:'users', name: 'UsersAdmin', component: UsersAdmin, meta: { resource: 'Pages.Users'} },
        { path:'roles', name: 'RolesAdmin', component: RolesAdmin, meta: { resource: 'Pages.Roles'} },
        { path:'rooms', name: 'RoomsAdmin', component: Rooms, meta: { resource: 'POKO_Rooms'} },
        { path: 'settings', name: 'CompanySettings', component: CompanySettings, meta: {resource: 'POKO_Ustawienia_Firmy'}},
        { path: 'dniwolne', name: 'DniWolne',component: AsyncDniWolne, meta: {resource: 'POKO_DniWolne_Dodawanie'}},
        { path: 'sendsmsconfiguration', name: 'SendSmsConfiguration',component: AsyncSMSSendConfiguration, meta: {resource: 'POKO_AndroidWysylkaSMSKOnfiguracja'}},
        { path: 'pokosmsconfiguration', name: 'PokoSmsConfiguration',component: AsyncPokoSmsConfiguration, meta: {resource: 'POKO_AndroidWysylkaSMSKOnfiguracja'}},
        { path: 'podpisy/szablony', name: 'SigningTemplates', component: AsyncSigningTemplates, meta: {resource: 'POKO_Podpisy_Szablony'}},
        { path: 'podpisy/terminale', name: 'SigningTerminals', component: AsyncSigningTerminals, meta: {resource: 'POKO_Podpisy_Terminale'}},
      ]
    },    
    { path: '/visitsrooms', name: 'VisitsRooms', component: AsyncVisitsRooms, meta: { resource: 'POKO_Wizyty_Gabinety'}},
    { path: '/clients', name: 'Clients', component: Clients, meta: { resource: 'POKO_Klienci'}},
    { path: '/trainees', name: 'Trainees', component: AsyncTrainees, meta: { resource: 'POKO_Kursanci', feature: 'GroupVisits'}},
    { path: '/p1bufor', name: 'P1Bufor', component: AsyncP1Bufor, meta: {resource: 'POKO_Bufor_P1', feature: 'IntegracjaP1'}},
    { path: '/therapists', name: 'Therapists', component: Therapists, meta: { resource: 'POKO_Terapeuci'}},
    { path: '/visits', name: 'Visits', component: Visits, meta: { resource: 'POKO_Wizyty'}},
    { path: '/reports', name: 'Reports', component: Reports, meta: { resource: 'POKO_Reports' }},
    { path: '/mycalendar', name: 'MyCalendar',component: MyCalendar, meta: {resource: 'POKO_Moj_Kalendarz'}},
    { path:'/groupvisits',name:'GroupVisits',component: AsyncGroupVisits},
    {path: '/categories', name:'Categories',component: AsyncCategories, meta: {resource: 'POKO_Kategorie_Opisow_Edycja'}},
    {path: '/descriptions', name:'Opisy',component: AsyncDescriptions, meta: {resource: 'POKO_Opisy_Edycja'}},
    {path: '/zabiegi', name:'Zabiegi',component: AsyncZabiegi, meta: {resource: 'POKO_Zabiegi'}},
    {path: '/fizykoterapia', name:'Fizykoterapia',component: AsyncVisitsZabiegi, meta: {resource: 'POKO_WizytyZabiegiKalendarz'}},
    {path: '/changepassword', name:'ChangePassword',component: AsyncChangePassword},
    {path: '/settings2fa',name:'Settings2FA',component: AsyncSettings2FA},
    {path: '/vouchery', name:'Vouchery',component: AsyncVouchery, meta: {resource: 'POKO_Vouchery', feature: 'Vouchery'}},
    {path: '/przerwy', name: 'Przerwy',component: AsyncPrzerwy, meta: {resource: 'POKO_Terapeuci_Przerwy'}},
    {path: '/rezerwy', name: 'Rezerwy',component: AsyncReserves, meta: {resource: 'POKO_Rezerwy'}},
    {path: '/sms', name: 'WysylkaSMS', component: AsyncSendSMS, meta: {resource: "POKO_Bramka_SMS"}},
    {path: '/sms-center', name: 'SMSCenter', component: AsyncSMSCenter, meta: {resource: "POKO_InformacjeSMS"}},
    {path: '/payu', name: 'PlatnosciPayU', component: AsyncPayU, meta: {resource: "POKO_PayU_PrzegladPlatnosci"}},
  ]
});
// Pełne wczytanie strony od razu na ekranie innym niż panel startowy (F5, przejście z nowej wersji): uprawnienia
// i ustawienia firmy pobierał dotąd tylko panel, więc sprawdzenie uprawnień odsyłało na panel, a kalendarze
// (ustawienia firmy) nie renderowały się.
function ensureSessionData()
{
  const loads = []
  if(store.state.account.permissions == null)
    loads.push(store.dispatch('account/getpermissions'))
  if(store.state.companySettingsModule.settings == null)
    loads.push(settingsService.GetCompanySettings().then(resp => store.dispatch('companySettingsModule/setCompanySettings', resp.data.result)))
  return Promise.all(loads).catch(() => {})
}

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    clearInterval(Vue.prototype.$timerVisits)
    clearInterval(Vue.prototype.$timerNear)
    clearInterval(Vue.prototype.$timerMyVisits)
    clearInterval(Vue.prototype.$timerMyNear)
    return next('/login');
  }
  const obj = JSON.parse(loggedIn)
    if(obj && obj.forceResetPasswordAtLogin)
    {
        if(to.path !== '/changepassword')
        {
        return next('/changepassword?force=true')
        }
    }
    if(obj && obj.forceSet2FAAtLogin)
    {
        if(to.path !== '/settings2fa' && to.path !== '/changepassword')
        {
         return next('/settings2fa?force=true')
        }
    }

  // tylko pierwsza nawigacja po wczytaniu strony: po zalogowaniu dane pobiera panel (jak wcześniej), a oczekiwanie
  // w strażniku przy przejściu z /login pozwalało ekranowi logowania wylogować świeżą sesję („Sesja wygasła”)
  if(loggedIn && authRequired && from.matched.length === 0)
    await ensureSessionData()

  const companySettings = store.state.companySettingsModule.settings;
  if (companySettings && companySettings.systemShutdownDate) {
    if (new Date() >= new Date(companySettings.systemShutdownDate) && to.path !== '/') {
      return next('/');
    }
  }

  if(to.meta.resource) {
    if(!ability.can('do',to.meta.resource))
    {
      if(to.meta.feature)
      {
        redirectIfNoFeature(to,from,next,to.meta.feature)
      }
      else {
        return next('/');
      }
    }
  }
  next();
})
